import * as React from 'react';
export const IcRomance = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M15.7 8.5a4.39 4.39 0 011.8.39 4.39 4.39 0 011.8-.39c.205.005.409.025.61.06A5.33 5.33 0 0014.6 4 5.6 5.6 0 0011 5.46 5.6 5.6 0 007.4 4 5.36 5.36 0 002 9.44C2 12.81 4.63 15.87 9.16 20l.49.45a2 2 0 002.7 0l.49-.44c.43-.39.83-.78 1.23-1.15-1.72-1.68-3.07-3.45-3.07-5.64a4.659 4.659 0 014.7-4.72zm3.6 2a2.82 2.82 0 00-1.8.73 2.84 2.84 0 00-1.8-.73 2.689 2.689 0 00-2.7 2.72c0 1.68 1.31 3.21 3.58 5.29l.24.22a1 1 0 001.35 0l.25-.22C20.69 16.43 22 14.9 22 13.22a2.69 2.69 0 00-2.7-2.72z'
      fill='currentColor'
    />
  </svg>
);
